import React from "react";

const CommitteeMember = (props) => {
  let image = require("../../src/images/committee/" +
    props.committeePhoto +
    ".jpg");
  return (
    <div className="card">
      <div className="card-content">
        <img className="responsive-img circle" src={image} alt="" />
        <span className="card-title">{props.committeeRole}</span>
        <h5>{props.committeeName}</h5>
        <h6>{props.committeeTeam}</h6>
        <p>{props.committeeAbout}</p>
      </div>
    </div>
  );
};

export default CommitteeMember;
